import { useState, useEffect } from 'react'
import InputRangeFilter from 'components/forms/InputRangeFilter'

export const PublishedRange = ({
  publishedRange,
  minMaxPublishedRange,
  onChange,
  onChangeComplete,
  toggleModal,
  toggleFilter,
  fullReport,
  upgradeReport
}) => {
  const [value, setValue] = useState(publishedRange || minMaxPublishedRange)

  //
  // In the case where e.g. the user clicked back/forward
  //
  useEffect(() => {
    const min = value?.min
    const max = value?.max

    if (!publishedRange) {
      setValue(minMaxPublishedRange)
    } else if (min !== publishedRange.min || max !== publishedRange.max) {
      setValue(publishedRange)
    }
  }, [publishedRange, minMaxPublishedRange])

  const handleClick = () => {
    const min = value?.min
    const max = value?.max

    if (min === max && min === minMaxPublishedRange.min) {
      setValue({ min, max: max - 1 })
    }
    if (min === max && max === minMaxPublishedRange.max) {
      setValue({ min: min - 1, max })
    }
  }

  return (
    <div onClick={handleClick}>
      <InputRangeFilter
        minValue={minMaxPublishedRange.min}
        maxValue={minMaxPublishedRange.max}
        step={1}
        value={value}
        onChange={val => {
          setValue(val)
          onChange && onChange(val)
        }}
        onChangeComplete={onChangeComplete}
        allowSameValues
        labelBottom
      />
    </div>
  )
}

export default PublishedRange
